import { Box, MenuItem, Select, Typography } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import IconButton from "../Button/IconButton";

/**
 * Common Incremental Pagination Component
 */

const IncrementalPagination = ({
  page,
  pageSize,
  dataLength,
  onPageChange,
  onPageSizeChange,
  pageSizeOptions = [10, 25, 50, 100],
}) => {
  const isFirstPage = Number(page) === 0;

  // Server-side incremental pagination
  // If API returns less than pageSize, no more pages
  const isLastPage = dataLength < pageSize;

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      m={2}
      px={2}
    >
      {/* Rows per page */}
      <Box display="flex" alignItems="center" gap={1}>
        <Typography variant="body2">Rows per page:</Typography>
        <Select
          size="small"
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
        >
          {pageSizeOptions.map((size) => (
            <MenuItem key={size} value={size}>
              {size}
            </MenuItem>
          ))}
        </Select>
      </Box>

      {/* Pagination controls */}
      <Box display="flex" alignItems="center" gap={1}>
        <IconButton
          variant={isFirstPage ? "disabled" : "primary"}
          size="small"
          icon={<ChevronLeftIcon />}
          // onClick={() => onPageChange(page - 1, isFirstPage)}
          onClick={() => {
            if (!isFirstPage) onPageChange(page - 1);
          }}
          isNotAllowed={isFirstPage}
          tooltip="Previous page"
          disabled={isFirstPage}
        />

        {/* Current Page */}
        <Box
          px={2}
          py={0.5}
          borderRadius={1}
          sx={{
            backgroundColor: "#f57c00",
            color: "#fff",
            minWidth: 32,
            textAlign: "center",
            fontWeight: 600,
          }}
        >
          {page + 1}
        </Box>

        <IconButton
          variant={isLastPage ? "disabled" : "primary"}
          size="small"
          icon={<ChevronRightIcon />}
          // onClick={() => onPageChange(page + 1, isLastPage)}
          onClick={() => {
            if (!isLastPage) onPageChange(page + 1);
          }}
          isNotAllowed={isLastPage}
          tooltip="Next page"
          disabled={isLastPage}
        />
      </Box>
    </Box>
  );
};

export default IncrementalPagination;
